/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Input, Row, Col, FormGroup, Label, Button } from 'reactstrap'

import InputNumber from 'rc-input-number';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import ConfirmationModal from '../../widgets/ConfirmationModal'

import {AppContext} from '../../AppContext';

class UserProperties extends React.Component
{

  closeConfirmationModal = null;

  componentDidMount()
  {
    this.getUserInfo();
  }

  confirmResetPassword()
  {
    let  modalText = 
    ( 
      <div>If you reset this user's password, a temporary one-time-use password will be generated.  
           The user will have to log in and change their password before they can proceed.  
        <br /><br />Are you sure you want to reset the password for {this.state.userInfo.username} ?</div>
    );
    this.closeConfirmationModal = this.resetPasswordConfirmed.bind(this);
    this.setState({confirmationModalIsOpen: true, modalText: modalText});
  }

  confirmToggleAccountStatus(event)
  {
    let modalText = ('locked' === this.state.userInfo.accountStatus ? 'Are you sure you want to un-lock this account?' :
      'Are you sure you want to lock this account');
    this.closeConfirmationModal = this.toggleAccountStatusConfirmed.bind(this);
    this.setState({confirmationModalIsOpen: true, modalText: modalText});
  }

  constructor(props)
  {
    super();

    this.state =
    {
      confirmationModalIsOpen: false,
      modalText: null,
      userInfo: null
    }

    this.confirmToggleAccountStatus = this.confirmToggleAccountStatus.bind(this);
    this.confirmResetPassword = this.confirmResetPassword.bind(this);
    this.sessionLimitChanged = this.sessionLimitChanged.bind(this);
    this.setInactivityLimit = this.setInactivityLimit.bind(this);
  }

  async getUserInfo()
  {
    let bodyData = {username: this.props.username};

    let result = await this.context.dbTwig.callRestAPI('icam', 'getUserInfo', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving user info');
    this.setState({ userInfo: result.jsonData });
  }

  async resetPasswordConfirmed(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});

    if (!confirmed) return;

    let bodyData = {};
    bodyData.username = this.state.userInfo.username;

    let result = await this.context.dbTwig.callRestAPI('icam', 'generateTemporaryPassword', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating temporary password');
    let jsx = (
      <div>
        A new password for {this.state.userInfo.username} has been generated.
        <br /><br />
        <CopyToClipboard text={result.jsonData.temporaryPassword} 
            onCopy={() => this.context.postNotification('info', 'Temporary password copied to paste buffer.')} >
          <span title='Click to copy...'>{result.jsonData.temporaryPassword}</span>
        </CopyToClipboard>
        <br /><br />
        Click on the password to copy it to your paste buffer so that you can send it to {this.state.userInfo.username}
      </div>);

    this.context.openAppModal('Temporary Password Generated.', jsx);
  }

  render()
  {
    if (null === this.state.userInfo) return null;

    let buttonText = ('active' === this.state.userInfo.accountStatus ? 'Lock Account' : 'Unlock Account');

    return (
      <div>
        <Row style={{paddingTop: '10px'}}>
          <Col sm="2">User</Col>
          <Col sm="3">
            {this.state.userInfo.firstName}&nbsp;{this.state.userInfo.middleName}&nbsp;{this.state.userInfo.lastName}
          </Col>
        { ( this.state.userInfo.apiUserId !== this.context.userUiProfile.apiUserId &&
          <Col sm='2' ><Button color='primary' onClick={this.confirmResetPassword}>Reset Password</Button></Col>            
        ) }
        </Row>
        <Row style={{paddingTop: '10px'}}>
          <Col sm='2'>Primary Email</Col>
          <Col sm='10'>
            <CopyToClipboard text={this.state.userInfo.emailAddress} 
                onCopy={() => this.context.postNotification('info', 'Email address copied to paste buffer.')} >
              <span title='Click to copy...'>{this.state.userInfo.emailAddress}</span>
            </CopyToClipboard>
          </Col>          
        </Row>
        <Row style={{paddingTop: '10px'}}>
          <Col sm='2'>Account Type</Col><Col sm='10'>{this.state.userInfo.accountType}</Col>
        </Row>
        <Row style={{paddingTop: '10px', lineHeight: '3.5'}}>
          <Col sm='2'>Account Status</Col>
          <Col sm='2'>{this.state.userInfo.accountStatus}</Col>
        { ( 'administrator' !== this.state.userInfo.accountType && ('active' === this.state.userInfo.accountStatus || 
            'locked' === this.state.userInfo.accountStatus) &&
            <Col sm='2' ><Button color='primary' onClick={this.confirmToggleAccountStatus}>{buttonText}</Button></Col>
        ) } 
        </Row>
        <FormGroup row>
          <Label sm="2" for="sessionLimit">Session Limit:</Label>
          <Col sm="2">
            <InputNumber id="sessionLimit" value={this.state.userInfo.sessionLimit} onChange={this.sessionLimitChanged} 
              precision={0} min={1} max={10} controls={true}
            />
          </Col>
        </FormGroup>
        <Row style={{paddingTop: '10px'}}>
          <Col sm='2'>Idle Time-Out Limit</Col>
          <Col sm='10'>
          <FormGroup check className="form-check-inline">
            <Label check>
              <Input type="radio" name="inactivityLimit" checked={(86400 === this.state.userInfo.sessionInactivityLimit ? 'checked' : '')} 
                  onChange={() => this.setInactivityLimit(86400)} />
              1 Day
            </Label>
          </FormGroup>
          <FormGroup check className="form-check-inline">
            <Label check>
              <Input type="radio" name="inactivityLimit" checked={(3600 === this.state.userInfo.sessionInactivityLimit ? 'checked' : '')} 
                  onChange={() => this.setInactivityLimit(3600)}  />
              1 Hour
            </Label>
          </FormGroup>
          <FormGroup check className="form-check-inline">
            <Label check>
              <Input type="radio" name="inactivityLimit" checked={(1800 === this.state.userInfo.sessionInactivityLimit ? 'checked' : '')} 
                  onChange={() => this.setInactivityLimit(1800)}  />
              30 Minutes
            </Label>
          </FormGroup>
          <FormGroup check className="form-check-inline">
            <Label check>
              <Input type="radio" name="inactivityLimit" checked={(600 === this.state.userInfo.sessionInactivityLimit ? 'checked' : '')} 
                  onChange={() => this.setInactivityLimit(600)}  />
              10 Minutes
            </Label>
          </FormGroup>
          </Col>
        </Row>
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.closeConfirmationModal}
          modalText={this.state.modalText}
        />
      </div>
    );
  }

  sessionLimitChanged(numVal, textVal)
  {
    let userInfo = this.state.userInfo;
    userInfo.sessionLimit = numVal;
    this.setState({userInfo: userInfo});
    this.updateUserProperties();
  }

  setInactivityLimit(limit)
  {
    let userInfo = this.state.userInfo;
    userInfo.sessionInactivityLimit = limit;
    this.setState({userInfo: userInfo});
    this.updateUserProperties();
  }

  async toggleAccountStatusConfirmed(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});

    if (!confirmed) return;

    let bodyData = {};
    bodyData.username = this.props.username;

    let result = await this.context.dbTwig.callRestAPI('icam', 'toggleAccountStatus', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error changing account status');
    this.context.postNotification('info', 'Account status changed.');
    let userInfo = this.state.userInfo;
    if ('locked' === userInfo.accountStatus)
      userInfo.accountStatus = 'active';
    else
      userInfo.accountStatus = 'locked';

    this.props.setRefreshRequired();
    this.setState({userInfo: userInfo})
  }

  async updateUserProperties()
  {
    let bodyData = {};
    bodyData.username = this.props.username;
    bodyData.sessionLimit = this.state.userInfo.sessionLimit;
    bodyData.sessionInactivityLimit = this.state.userInfo.sessionInactivityLimit;

    let result = await this.context.dbTwig.callRestAPI('icam', 'updateUserProperties', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error changing user info');
    this.context.postNotification('info', 'User info saved.');
  }
}

UserProperties.contextType = AppContext;

export default UserProperties